@import 'fluid-form-label.theme.less';

@import '../../styles/mixins/fluid-form-elements.mixin.less';
@import '../../styles/mixins/fluid-text-format.mixin.less';

// ================================================================ //
// -- Theme Definition

:host {
  display: block;

  *, ::after, ::before {
    box-sizing: border-box;
  }

  .fluid-form-label {

    /**
     * LEGACY THEME
     */
    &.legacy {
      @import '../../styles/variables-iuw-legacy.less';
      @form-label-tokens: @form-label-tokens-legacy;
      @form-label();
    }

    /**
     * LIBERTY MUTUAL THEME
     */
    &.lm {
      @import '../../styles/variables-lm.less';
      @form-label-tokens: @form-label-tokens-lm;
      @form-label();
    }

    /**
     * LM CORPORATE THEME
     */
    &.corp, &.default {
      @import '../../styles/variables-lm-corp.less';
      @form-label-tokens: @form-label-tokens-corp;
      @form-label();
    }

    /**
     * PORTAL THEME
     */
    &.portal {
      @import '../../styles/variables-lm-portal.less';
      @form-label-tokens: @form-label-tokens-portal;
      @form-label();
    }
  }
}


// ================================================================ //
// -- Component Detached Ruleset

@form-label: {
  @label: @form-label-tokens[@label];
  @disabled: @label[@disabled];

  // ==== Computed Variables

  @right-offset: if((@label[left] = auto), 4px, (@label[left] * 2));

  // ---------------- //

  width: 100%;
  font-family: @font-family;
  font-size: @font-size;
  line-height: @form-label-line-height;

  &.inline {
    padding: 0;
  }

  // ==== Label Container (Text + Popover)

  .label-container {
    max-width: calc(100% - @right-offset);
    display: inline-block;
    position: relative;
    top: @label[top];
    left: @label[left];
    padding-left: @label[padding-left];
    padding-right: @label[padding-right];
    padding-bottom: @form-label-tokens[padding-bottom];
    z-index: 1;

    // == Notch in Form Element Border

    .form-label-border-notch();

    // == Position Override

    &.reset-position {
      max-width: 100%;
      top: auto;
      left: auto;
      padding: 0;

      .form-label {
        background-color: transparent;
      }
    }

    &.popover-open {
      z-index: @stacking-context[sidebar-body] + 1; // Set stacking context priority to prevent overlap
    }
  }

  // ==== Label Element

  .form-label {
    max-width: 100%;
    display: inline-flex;
    align-items: flex-start;
    font-family: inherit;
    font-size: @label[font-size];
    font-weight: @label[font-weight];
    color: @label[color];
    text-transform: none;
    overflow: hidden;

    .transition(@property: color, opacity; @duration: short);

    // == Disabled State

    &.form-element-disabled {
      color: @disabled[color];

      .outer-text-stroke();
    }

    // == Error State

    &.has-error {
      color: @color-error;
    }

    // == Label Adjacent to Form Element

    &.inline-question {
      font-size: @font-size;
      color: @color-text;
    }

    // == Text Overflow

    &.text-overflow-ellipsis {
      .fluid-label-text {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    &.text-overflow-clip {
      .fluid-label-text {
        text-overflow: clip;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    &.text-overflow-wrap {
      display: block;
      line-height: 1.25;

      .fluid-label-text {
        overflow-wrap: break-word;
        hyphens: auto;
      }
    }

    // == w/ Helptext Popover

    fluid-popover {
      margin-left: 0.4em;
    }
  }

  // ==== Label Text

  .fluid-label-text {
    flex: 0 1 auto;
    transition: inherit;
  }

  // ==== Supplementary Label

  .supplementary {
    color: inherit;
    padding-left: 0.25em;
    transition: inherit;
  }

  // ==== Required "*"

  .required {
    color: @color-error;
    font-size: 1em;
    padding-left: 0.25em;
    transition: inherit;
  }
}


// ================================================================ //
// -- Mixins

/**
 * Creates a 1px white line (pseudo-element) used to override a small
 * segment of FLUID Form Element's top border & create a visual "notch"
 * that is wide enough to accommodate Form Label's text (i.e.
 * aesthetically similar to a <fieldset> element's <legend>).
 */
.form-label-border-notch() {
  &:not(.reset-position) {
    &::after {
      height: 2.5px;
      display: block;
      position: absolute;
      top: calc(100% - @label[top] - 0.5px);
      left: 0;
      right: 0;
      background-color: @white;
      content: if((@label[top] > 0), "", false);
      z-index: -1;
    }

    &.form-element-disabled {
      &::after {
        background-color: @form-field-background-disabled;
      }
    }
  }
}
